import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";

export default class WorkOrders extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	componentDidMount(){
		//to autoset the filters to todays date, would be nice to just replace this at some point with something they might use more
		localStorage.setItem('table-preferences-WorkOrders',
			JSON.stringify({"default": {"filter":{
						"date":[{"start":moment().format("YYYY-MM-DD 00:00:00"), "end":moment().format("YYYY-MM-DD 23:59:59")}]
					},
				"startDate":moment().format("YYYY-MM-DD 00:00:00"), "endDate":moment().format("YYYY-MM-DD 23:59:59")
				}}))
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [

			{
				Header: "Date",
				id: 'appointment_start',
				accessor: obj => (moment(obj.appointment_start).format("MM/DD/YYYY")),
			},
			{
				Header: "Time",
				id: 'appointment_end',
				accessor: obj =>  obj.appointment_start ? (moment(obj.appointment_start).local().format('HHmm') + "-" + moment(obj.appointment_end).local().format('HHmm')) : "",

			},
			{
				Header: "Employee",
				id: 'creator',
				accessor: obj => obj.field_engineers ? (obj.field_engineers.name_first + ' ' + obj.field_engineers.name_last) : '',
			},
			{
				Header: "Rate / Hr",
				id: 'rate',
				accessor: obj => "$125"
			},
			{
				Header: "End User",
				id: 'customer',
				accessor: obj => obj.customers ? (obj.customers.name) : '',
			},
			{
				Header: "Description",
				id: 'summary',
				accessor: obj => obj.summary,
			},
			{
				Header: "Location",
				id: 'location',
				accessor: obj => obj.customers_locations ? (obj.customers_locations.city + ", " + obj.customers_locations.state) : "",
			},
			{
				sortable: false,
				Header: "FreshDesk",
				id: "fresh_ticket",
				/** @param {Tickets_Object} obj */
				accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
				Cell: props => (
					<span>
						<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
					</span>
				)
			},
			{
				Header: "Total Invoice",
				id: 'invoice',
				accessor: obj => obj.tickets_financialss[0] ? "=" + parseFloat(obj.tickets_financialss[0]?.labor_amount).toFixed(2) + " + " + parseFloat(obj.tickets_financialss[0]?.virus_sales).toFixed(2) + " + " + parseFloat(obj.tickets_financialss[0]?.parts_amount).toFixed(2) : "",
			},

			{
				Header: "Type",
				id: 'type',
				accessor: obj => obj.tickets_financialss[0] ? (obj.tickets_financialss[0].payment_type === 1 ? "C" : obj.tickets_financialss[0].payment_type === 2 ? "" : obj.tickets_financialss[0].payment_type === 3 ? "CC" :  "Send Invoice") : "",
			},

			{
				Header: "Notes",
				id: 'notes',
				accessor: obj => obj.tickets_financialss[0]?.notes?.replace(/[\r\n]+/g, " "),
			}

		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Work Orders','')}
							{this.renderDateRangeSearch()}
							{this.renderHeaderRight("Work_Orders", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000, 10000]}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
